import React from 'react'
import { Route, Switch } from 'react-router'
import ReportTransportChanges from './ReportTransportChanges'

const Components = props => (
    <Switch>
        <Route exact path={props.match.url} component={ReportTransportChanges} />
    </Switch>
)

export default Components
